// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SortLabel--moderator":"fm_a bha_hm","SortLabel__newFeature":"fm_b bha_uc bha_ur"};